// Mock data for AgriLink
import { mapFarms } from './mapMockData';

export const mockUser = {
  id: '1',
  email: 'admin@agrilink.dev',
  firstName: 'Admin',
  lastName: 'User',
  role: 'admin',
  avatarUrl: null
};

// Use farms from mapMockData for consistency
export const mockFarms = mapFarms.map(farm => ({
  id: farm.id,
  name: farm.name,
  location: farm.location,
  stations: farm.totalStations,
  activeStations: farm.activeStations
}));
